import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { CustomstorageService } from '../../services/customstorage.service';
import { RestService } from '../../services/rest.service';
import { CustomEventService } from '../../services/custom-event.service';
import { CookieService } from 'ngx-cookie-service';
declare var cookieAcceptDeclineAction:any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  
  public isCookiePolicy = 'no';
  public showHideCookieDiv = 'show';
  public base_url = environment.baseUrl;
  public cookiePolDisplayHalf = "";
  public cookiePolDisplay = "";
  public bs_slug = "";
  public showCookiePopup = false;
  public cookiePolDisplayPart = 'less';
  public copyrightYear: any = '2024';
  public footerLogo = "https://api25.bookyup.co.uk/assets/uploads/business/logo/default-business-logo.png";
  constructor(
    public storage: CustomstorageService,
    private cookieService: CookieService,
    public restProvider: RestService,
    public router: Router,
    public customEvent: CustomEventService
  ) {
    /* this.customEvent.getRefreshHeaderFooter().subscribe(x => {
      this.loadData();
    }); */
    /* router.events.subscribe(async val => {
      this.gettingOrderDeviceOsDetails();
    }) */
  }
  ngOnInit() {
    let d = new Date();
    this.copyrightYear = d.getFullYear();
    this.loadData();
    this.getCookiePolAccDetails();
    this.gettingOrderDeviceOsDetails();
  }
  async gettingOrderDeviceOsDetails(){
    // this is js localstorage
    // let orderDeviceOsType = await this.storage.getLocalstorage('orderDeviceOsType');
    let orderDeviceOsType = await localStorage.getItem('orderDeviceOsType');    
    if(orderDeviceOsType != undefined && orderDeviceOsType != null && (orderDeviceOsType == "ios" || orderDeviceOsType == "android")){
      this.showHideCookieDiv='hide';
    }else{
      this.showHideCookieDiv='show';
    }
  }
  async loadData() {
    let bsDetails = await this.storage.getLocalstorage('business_details');
    console.log(bsDetails.business_slug)
    if (bsDetails != undefined && bsDetails != null) {
      if (bsDetails.business_logo != undefined && bsDetails.business_logo != null && bsDetails.business_logo != '') {
        this.footerLogo = bsDetails.business_logo;
      }
      if (bsDetails.restaurant_ordering_logo != undefined && bsDetails.restaurant_ordering_logo != null && bsDetails.restaurant_ordering_logo != '') {
        this.footerLogo = bsDetails.restaurant_ordering_logo;
      }
    }else{
      let restaurant_ordering_logo = await this.storage.getLocalstorage('restaurant_ordering_logo');
      if(restaurant_ordering_logo != undefined && restaurant_ordering_logo!= null && restaurant_ordering_logo!=''){
        this.footerLogo=restaurant_ordering_logo;
      }
    }
  }

  public async getCookiePolAccDetails() {
    let bsDetails = await this.storage.getLocalstorage('business_details');
    if(bsDetails.business_slug != undefined && bsDetails.business_slug != null && bsDetails.business_slug != ''){
      this.bs_slug = bsDetails.business_slug;
    }
    let t1 = this.cookieService.get('cookiePolicyAcceptDecline');
    if (t1 != undefined && t1 != null && t1 != '') {
      this.showCookiePopup = false;
    } else {
      let payload = {
        'req_page': "cookie-policy-short",
        'bs_slug': this.bs_slug
      }
      this.restProvider.postdataapi(payload, "information/custom-cms").subscribe((data:any) => {
        if (data.cms_page.page_content != undefined && data.cms_page.page_content != null && data.cms_page.page_content != '') {
          this.cookiePolDisplayHalf = data.cms_page.page_content
          // let t1 = data.cms_page.page_content.split('.');
          // this.cookiePolDisplayHalf=t1[0]!=undefined && t1[0]!=null?this.cookiePolDisplayHalf+=t1[0]+". ":"";
          // this.cookiePolDisplayHalf=t1[1]!=undefined && t1[1]!=null?this.cookiePolDisplayHalf+=t1[1]+". ":"";
          // console.log(t1)
        }
        this.showCookiePopup = true;
        this.cookiePolDisplay = this.cookiePolDisplayHalf;
        this.cookiePolDisplayPart = "less";
      });
    }
  }

  public acceptCookie() {
    this.customEvent.setCookieCheck('yes');
    let gtagScript = environment.gtagScript;
    let gtagNoScript = environment.gtagNoScript;
    let analyticsScript1 = environment.analyticsScript1;
    let analyticsScript2 = environment.analyticsScript2;
    let metaScript = environment.metaScript;
    let metaNoScript = environment.metaNoScript;
    let tiktokScript = environment.tiktokScript;
    let linkedinScript1 = environment.linkedinScript1;
    let linkedinScript2 = environment.linkedinScript2;
    let linkedinNoScript = environment.linkedinNoScript;
    cookieAcceptDeclineAction(gtagScript, gtagNoScript, analyticsScript1, analyticsScript2, metaScript, metaNoScript, tiktokScript, linkedinScript1, linkedinScript2, linkedinNoScript);
    this.cookieService.set('cookiePolicyAcceptDecline', 'accept', { 'path': '/' });
    this.showCookiePopup = false;
    this.cookiePolDisplay = this.cookiePolDisplayHalf;
    this.cookiePolDisplayPart = "less";
    // this.loginpopS.opencommonpopup("Accepting cookies","Thanks for consenting to the cookies policy.","normal");
  }
  public declineCookie(){
    
    this.router.navigate(["/information/cookies-policy"]);
  }
}
